import {
  EnvironmentSpecific,
  EnvironmentName,
  EnvironmentType,
  EnvironmentSystem,
} from "./environment.interface";

import { citychallenge } from "./environment.citychallenge";
import { energywalks } from "./environment.energywalks";
import { intractive } from "./environment.intractive";
import { energyplatform } from "./environment.energyplatform";

type EnvironmentSelect = {
  select: <P, D = undefined>(
    value: Partial<{ [key in EnvironmentName]: P }> & { default: D }
  ) => P | D;
};

type EvironmentTypeSelect = {
  selectType: <P, D = undefined>(
    value: Partial<{ [key in EnvironmentType]: P }> & { default: D }
  ) => P | D;
};

type Environment = EnvironmentSystem &
  EnvironmentSpecific &
  EnvironmentSelect &
  EvironmentTypeSelect;

const environmentMap = {
  citychallenge,
  energywalks,
  intractive,
  energyplatform,
};

const EnvironmentDefaults: Partial<Environment> = {
  dimmedMapStyle: "mapbox://styles/heartlessnl/ckkpf5i0e16tw17o4fuhmb03x",
  dimmedMapStyleDark: "mapbox://styles/heartlessnl/ckoob03j30r8w17qk63o5nh0o",
  fullMapStyle: "mapbox://styles/heartlessnl/ckkpfn4e917bc17o42caissee",
  fullMapStyleDark: "mapbox://styles/heartlessnl/ckoob03j30r8w17qk63o5nh0o",
};

export const DEFAULT_ENVIRONMENT: EnvironmentSystem = {
  version: "1",
  buildNumber: "1",
  OS: "builder",
  systemVersion: "1",
  deviceType: "default",
  deviceId: "default_environment",
  /*
  deviceInfo: {
    getBatteryLevel: async () => 100,
    getDeviceLanguage: () => ({
      full: "en-EN",
      short: "en",
    }),
    checkIsARSupported: async () => "UNSUPPORTED",
    requestARInstall: async () => {
    },
    hasGyroscope: async () => false,
  },*/
  Dimensions: {
    get: () => ({
      width: 380,
      height: 600,
    }),
  },
};

export const Environment: Environment = {} as any;

export const getEnvironment = (
  envName: EnvironmentName,
  system: EnvironmentSystem = DEFAULT_ENVIRONMENT
) => {
  const specific = environmentMap[envName];

  const environment: Environment = {
    ...EnvironmentDefaults,
    ...system,
    ...specific,
    select: (value) => {
      return value[specific.environmentName] || value["default"];
    },
    selectType: (value) => {
      return value[specific.type] || value["default"];
    },
  };

  return environment;
};

export const setupEnvironment = (
  envName: EnvironmentName,
  system: EnvironmentSystem
) => {
  Object.assign(Environment, getEnvironment(envName, system));
};

setupEnvironment("intractive", DEFAULT_ENVIRONMENT);

export const switchEnvironment = (envName: EnvironmentName) => {
  Object.assign(Environment, environmentMap[envName]);
};
